import { render, staticRenderFns } from "./clinicRevenueOverview.vue?vue&type=template&id=163e4522&scoped=true"
import script from "./clinicRevenueOverview.vue?vue&type=script&lang=js"
export * from "./clinicRevenueOverview.vue?vue&type=script&lang=js"
import style0 from "./clinicRevenueOverview.vue?vue&type=style&index=0&id=163e4522&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e4522",
  null
  
)

export default component.exports